import type { RGB } from '@/std/color';

/** Gera um número aleatório. min e max são inclusos */
export function randomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

/** Gera uma cor aleatória no formato RGB */
export function randomColorRGB(): RGB {
    return {
        b: randomInt(0, 255),
        g: randomInt(0, 255),
        r: randomInt(0, 255),
    };
}

/** Gera uma cor aleatória no formato hex */
export function randomColorHex(): string {
    const hex = Math.floor(Math.random() * 16777215).toString(16); // 16777215 is 0xFFFFFF in decimal
    return `#${hex.padStart(6, '0')}`; // Ensures it's always 6 characters
}
